import { render, staticRenderFns } from "./workPoolList.vue?vue&type=template&id=670431fb&scoped=true"
import script from "./workPoolList.vue?vue&type=script&lang=js"
export * from "./workPoolList.vue?vue&type=script&lang=js"
import style0 from "./workPoolList.vue?vue&type=style&index=0&id=670431fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670431fb",
  null
  
)

export default component.exports